document.addEventListener("DOMContentLoaded", function () {
  const snowBox = document.createElement("div");
  snowBox.className = "snow";
  document.body.appendChild(snowBox);

  function createSnowflake() {
    const flake = document.createElement("div");
    flake.className = "snowflake";
    flake.innerHTML = "❄︎";
    flake.style.fontSize = "10px";   // chhota size
flake.style.color = "#ffffff";  // white color


    flake.style.left = Math.random() * 100 + "vw";
    flake.style.fontSize = "16px";           // mostly same size
    flake.style.opacity = "0.8";             // clean look
    flake.style.animationDuration = "8s";    // smooth fall

    snowBox.appendChild(flake);

    setTimeout(() => {
      flake.remove();
    }, 8000);
  }

  // 👇 stable continuous snowfall (video jaisa)
  setInterval(createSnowflake, 400);
});
